(function() {
  "use strict";

  angular.module("sempraWebapp").constant("fiTranslations", {
    MESSAGE:"Ilmoitus",
    ERROR_TITLE:"Virhe",
    ERROR_MESSAGE:"Toiminnon suorittamisessa tapahtui virhe",
    ERROR_LOGIN:"Sisäänkirjautumisessa tapahtui virhe. Sähköpostiosoite tai salasana ei kelpaa",
    ERROR_LOGIN_ROLE:"Role for current application brand is not valid",
    OK:"OK",
    CANCEL:"Peruuta",
    YES:"Kyllä",
    NO:"Ei",
    FROM:"Alkaen",
    TO:"Päättyen",
    DELETE:"Poista",
    SIGN_OUT:"Kirjaudu ulos",
    NAME:"Nimi",
    DATE:"Päiväys",
    PIECES:"Kappaletta",
    HOURS:"Tuntia",
    DAYS:"Päivää",
    MONTH:"Kuukausi",
    MONTHS:"Kuukautta",
    YEAR:"Vuosi",
    BOX:"Box",
    SEARCH:"Haku",
    ALL_USERS:"Kaikki käyttäjät",
    ARE_YOU_SURE:"Oletko varma?",
    BACK:"Takaisin",
    AMOUNT:"Määrä",
    DESCRIPTION:"Kuvaus",
    FORGOT_PASSWORD_ERROR_MSG:"Jokin meni pieleen. Tarkasta sähköpostiosoitteesi ja yritä uudelleen",
    REQUIRED_FIELD:"Pakollinen kenttä",
    LOGOUT_TITLE:"Oletko varma, että haluat kirjautua ulos?",
    LOGOUT_MSG:"Kaikki tallentamattomat tiedot katoavat",
    ACTIVATION_ACCOUNT:"Tilisi aktivointi onnistui",
    UNKNOWN_ERRROR_NOTIFICATION:"Tuntematon virhe",
    CONTINUE:"Jatka",
    DATA_NOT_AVAILABLE:"Tietoja ei ole saatavilla",
    SELECT:"Valitse",
    SELECT_CURRENCY:"Valitse valuutta",
    UPLOAD:"Lataa",
    PHONE:"Puhelin",
    WEBSITE:"Nettisivu",
    WORKING_HOURS:"Aukioloaika",
    INSERT:"Lisää",
    TEXT:"Teksti",
    CREATED:"Luotu",
    VALID_UNTIL:"Voimassa asti",
    SAVE:"Tallenna",
    TOKENS:"Poletit",
    DELETE_COMPANY_HISTORY:"Poista yrityshistoria ",
    DELETE_COMPANY_HISTORY_MESSAGE:" VAROITUS: Tämän painikkeen painamisen jälkeen kaikki autopesusi tapahtumat poistetaan pysyvästi! Näitä tietoja ei voida palauttaa poistamisen jälkeen.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Oletko varma, että haluat pysyvästi poistaa tapahtumatiedot?",
    HISTORY_SUCCESSFULY_DELETED:"Historia poistettu onnistuneesti",
    HELP:"Apua",
    VALUE:"Arvo",
    ACTIVATING_ACCOUNT_ERROR:"R2W tilin aktivoinnissa tapahtui virhe. Yritä uudelleen ja ongelman uusiutuessa ota yhteyttä meidän tukeen: support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Tervetuloa Kärcher Car Wash sovellukseen",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Tervetuloa R2W:lle",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Syötä uusi salasanasi ja vahvista se aktivoidaksesi R2W tilisi. Teidät kirjataan automaattisesti sisään onnistumisen merkiksi",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Voit muuttaa tilisi asetuksia myöhemmin aplikaatiossa",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Syötä uusi salasanasi ja vahvista se vaihtaaksesi vanha salasanasi. Teidät kirjataan automaattisesti sisään oonistumisen merkiksi",
    RESET_PASSWORD_WELCOME_MSG_3:"Voit muuttaa tilisi asetuksia myöhemmin aplikaatiossa",
    ENTER_NEW_PASSWORD:"Syötä uusi salasana",
    REPEAT_NEW_PASSWORD:"Syötä uusi salasana uudelleen",
    PASSWORD_MIN_LENGTH:"Salasanan pitää olla vähintään 8 merkkiä pitkä",
    PASSWORD_MAX_LENGHT:"Salasanan täytyy olla alle 32 merkkiä pitkä",
    PASSWORD_PATTERN:"Salasanan täytii sisältää vähintään yksi iso kirjain ja yksi pieni kirjain",
    PASSWORD_MATCH:"Salasanat eivät täsmää",
    ACTIVATE:"Aktivoi",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:" Lähetit pyynnön onnistuneesti. Tarkista sähköpostistasi vahvistusviesti",
    VALIDATION_REQUIRED:"Pakollinen kenttä",
    VALIDATION_EMAIL:"Virheellinen sähköpostiosoite",
    VALIDATION_INTEGER_NUMBER:"Anna kokonaislukuarvo",
    VALIDATION_HOURS_VALUE:"Arvon täytyy olla väliltä 0-23",
    VALIDATION_MINUTES_VALUE:"Arvon täytyy olla väliltä 0-59",
    VALIDATION_NOT_A_DATE:"Arvo ei ole päivämäärä",
    VALIDATION_FROM:"Päivämäärästä alkaen",
    VALIDATION_TO:"Päivämäärään asti",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Kyseinen tietue on jo olemassa tietokannassa",
    PASSWORD_VALIDATION_PATTERN_NEW:"Salasanan täytyy sisältää vähintään yksi numero, yksi pieni kirjain ja yksi iso kirjain. Välilyönnit eivät ole sallittu",
    VALIDATION_PERCENT_VALUE:"Arvon täytyy olla väliltä 1-999",
    NUMBERS_ONLY_100:"Lukumäärä sataan asti",
    NUMBERS_ONLY_1000:"Lukumäärä tuhanteen asti",
    POSITIVE_NUMBERS_ONLY:"Vain numero",
    GRID_PAGER_PAGE:"Sivu",
    GRID_PAGER_ROWS_PER_PAGE:"Riviä sivulla",
    GRID_PAGER_PAGE_OF:"yhteensä",
    BREAD_CRUMBS_HOME:"Koti",
    BREAD_CRUMBS_DASHBOARD_TECH:"Dashboard technology",
    BREAD_CRUMBS_DETAILS:"Tiedot",
    BREAD_CRUMBS_SETTINGS:"Asetukset",
    BREAD_CRUMBS_WORKING_HOURS:"Käyttötunnit",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Päivä liikevaihto raportti",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Keskiarvo liikevaihto tunneittain",
    BREAD_CRUMBS_NEW_USER_GROUP:"Luo käyttäjäryhmä",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Muokka käyttäjäryhmää",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Luo kampanjasivu",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Muokkaa kampanjasivua",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Luo kampanja",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Muokkaa kampanjaa",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Jakson yhteenveto",
    LOGIN:"Kirjaudu sisään",
    EMAIL:"Sähköposti",
    PASSWORD:"Salasana",
    LANGUAGE:"Kieli",
    FORGOT_PASSWORD:"Unohtuiko salasana?",
    SUBMIT:"Lähetä",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Odottavien hälytysten määrä",
    HEADER_VIEW_ALL_ALARMS:"Näytä kaikki hälyytykset",
    HEADER_MY_ACCOUNT:"Minun tilini",
    HEADER_ACCOUNT_MANAGEMENT:"Tilin hallinta",
    ACCOUNT_ALREADY_EXIST:"Sähköposti on jo käytössä",
    NEWSLETTER_CONFIRMATION:"Lähetä sähköposti vikatilasta",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Päivittäinen talouskatsaus",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Dashboard Technology",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Etusivu",
    ASIDE_MENU_ALARMS:"Viestit",
    ASIDE_MENU_FACILITIES:"Facilities",
    ASIDE_MENU_REPORTS:"Raportit",
    ASIDE_MENU_REPORT:"Valittu raportti",
    ASIDE_MENU_LOYALTY:"Uskollisuus",
    ASIDE_MENU_USER_GROUPS:"Käyttäjäryhmät",
    ASIDE_MENU_PERIODIC_SUMMARY:"Aikajakson yhteenveto",
    ASIDE_MENU_MANAGING_TOKENS:"Polettien hallinta",
    ASIDE_MENU_NEWS:"Uutiset",
    DAILY_FINANCES_TOTAL_MONEY:"Rahaa yhteensä",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Rahaa yhteensä kaikki laitteet",
    DAILY_FINANCES_TOTAL_COINS:"Metallisia polettia käytetty yhteensä",
    DAILY_FINANCES_DOWNLOAD_CSV:"Lataa CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Käteinen",
    DAILY_FINANCES_CHANGER:"Käteinen vaihtajassa",
    DAILY_FINANCES_COINS:"Tokens/Eurokey",
    REPORTS_FILTER:"Suodatin",
    REPORTS_TYPE_OF_REPORT:"Raportin tyyppi",
    REPORTS_CHOOSE_FACILITY:"Valitse laite",
    REPORTS_PERIOD_1:"Jakso 1",
    REPORTS_PERIOD_2:"Jakso 2",
    MONEY_BY_DATE_REPORT:"Päivän tulot",
    R2W_BY_DATE_REPORT:"Päivän tulot R2W poleteista",
    COINS_BY_DATE_REPORT:"Käytetyt poletit yhteensä per päivä",
    AVG_MONEY_BY_HOUR_REPORT:"Keskiarvo tulo per tunti",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Keskiarvo tulo päivässä per viikko",
    AVG_MONEY_BY_BOX_REPORT:"Kulutus per paikka",
    COMPARE_PERIODS_REPORT:"Laitteiden vertailuraportti",
    TOTAL_USERS_BY_GROUP:"Yhteenlasketut käynnit R2W aplikaatiossa päivässä",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"Käyttäjät",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"Käynnit",
    VISITS_COUNT_REPORT:"R2W aplikaation käyttäjät verrattuna käyntimäärään",
    LOYALTY_PER_DAY_REPORT:"Paikallisten polettien käyttö per päivä",
    LOYALTY_PER_PAYMENT_METHOD:"Annettuja paikallisia poletteja per maksutapa",
    VISITS:"Käyntejä",
    VISIT:"Käynti",
    TOTAL_SPENT_MONEY:"Yhteenlaskettu tulo",
    MONEY:"Raha",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Yhteenlaskettu tulo jaksolla",
    DOWNLOAD_CSV:"Lataa CSV",
    TOTAL_SPENT_COINS:"Poletteja käytetty yhteensä",
    TOTAL_USERS:"Käyttäjiä yhteensä",
    TOTAL_CREDIT_GIVEN:"Käytettyjen virtuaalisten polettejen määrä yhteensä",
    EUROKEY_BY_DATE_REPORT:"Total Eurokey payments by date",
    TOTAL_SPENT_EUROKEY:"Yhteenlaskettu kulutus",
    SELECT_TYPE_OF_REPORT:"Valitse raportin tyyppi",
    NUMBER_OF_VISITS_TITLE:"Käyntien määrä",
    NUMBER_OF_USERS_TITLE:"Käyttäjien määrä",
    PIECES_TITLE:"Kappaletta",
    TOTAL_VISITS:"Käynnit yhteensä",
    TOKENS_TITLE:"poletit",
    SEARCH_USERS_NO_RESULTS:"Käyttäjiä ei löytynyt valitulla hakutermillä",
    SEARCH_USERS:"Etsi käyttäjiä",
    SEARCH_TELEPHONES:"Etsi käyttäjiä puhelinnumerolla",
    ADD_USER_TO_GROUP:"Lisää käyttäjä ryhmään",
    REMOVE_USER_FROM_GROUP:"Poista käyttäjä ryhmästä",
    USER_GROUP_NAME_REQUIRED:"Käyttäjäryhmän nimi vaaditaan",
    USER_GROUP_NAME:"Käyttäjäryhmän nimi",
    USER_GROUPS_OVERVIEW:"Käyttäjäryhmien yhteenveto",
    USER_COUNT:"Käyttäjämäärä",
    NEW_USER_GROUP:"Luo uusi käyttäjäryhmä",
    DELETE_USER_GROUP:"Poista käyttäjäryhmä",
    UPDATE_USER_GROUP:"Muokkaa käyttäjäryhmää",
    DELETE_USER_GROUP_ERROR:"Käyttäjäryhmää poistettaessa tapahtui virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
    CONFIRM_DELETE_USER_GROUP:"Oletko varma, että haluat poistaa valitun käyttäjäryhmän",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Uskollisuus toimenpiteet poistettavalle käyttäjäryhmälle ei ole enää käytössä",
    GROUP_NAME_MAX_LENGTH:"Ryhmän nimi pitää olla pienempi kuin 255 merkkiä",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Käyttäjä on jo valitussa ryhmässä",
    MISSING_USER:"Käyttäjä puuttuu",
    USER_NOT_ON_LIST:"Käyttäjä ei ole aktiivisessa käyttäjäryhmässä. Tarkasta onko sähköpostiosoite oikein ja yritä uudelleen",
    UPLOAD_USER_GROUP:"Lataa käyttäjäryhmä *.CSV tiedostosta",
    UKNOWN_USERS:"Tuntemattomien käyttäjien lista",
    CAMPAIGN_TEMPLATE_RULE:"Suodatin",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Kampanjasivua poistettaessa tapahtui virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Haluatko varmasti poistaa valitun kampanjasivun",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Haluatko varmasti poistaa valitun kampanjasivun",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Kampanjasivujen yhteenveto",
    DELETE_CAMPAIGN_TEMPLATE:"Poista kampanjasivu",
    UPDATE_CAMPAIGN_TEMPLATE:"Muokkaa kampanjasivua",
    CREATE_CAMPAIGN_TEMPLATE:"Luo kampanjasivu",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Kampanjasivun nimi vaaditaan",
    CAMPAIGN_TEMPLATE_NAME:"Kampanjasivun nimi",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Vaadittu kenttä",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Anna prosentti %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Ylimääräinen aika",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Valitse ensin tyyppi. Pesupaikkoja vai pieniä laitteita.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Poista sääntö",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Alkaen",
    CAMPAIGN_TEMPLATE_RULE_TO:"asti",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"tuntia",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuuttia",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Uusi sääntö käynti määrille",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Uusi sääntö käytetyille poleteille",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Uusi sääntö viikonpäiville",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Lisää sivun sääntö",
    CAMPAIGN_TEMPLATE_RULE_1:"Jokainen",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Jokainen",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"poletteja käytetty vähemmän kuin",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"käyntejä vähemmän kuin",
    CAMPAIGN_TEMPLATE_RULE_3:"päiviä",
    CAMPAIGN_TEMPLATE_RULE_4:"poletteja",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Sääntölistaus on tyhjä",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Päivämäärä ei voi olla menneisyydessä",
    DELETE_CAMPAIGN_ERROR:"Kampanjaa poistettaessa tapahtui virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
    CONFIRM_DELETE_CAMPAIGN:"Haluatko varmasti poistaa valitun kampanjan?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W ei ole vastuussa tämän toimen aiheuttamasta käyttäjäkokemuksesta.",
    CAMPAIGNS_OVERVIEW:"Kampanjojen yhteenveto",
    DELETE_CAMPAIGN:"Poista kampanja",
    UPDATE_CAMPAIGN:"Muokkaa kampanjaa",
    CREATE_CAMPAIGN:"Luo uusi kampanja",
    CAMPAIGN_ACTIVE:"Aktiivinen",
    CAMPAIGN_TEMPLATE:"Pohja",
    CAMPAIGN_GROUPS:"Ryhmät",
    CAMPAIGN_ALL_USERS:"Kaikki käyttäjät",
    CAMPAIGN_NAME:"Kampanjan nimi",
    CAMPAIGN_NAME_REQUIRED:"Vaadittu",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Käyttäjien määrä lähellä kynnystä per päivä",
    MESSAGE_TO_USERS:"Viesti valituille käyttäjille",
    SEND_MESSAGE:"Lähetä viesti",
    THRESHOLD:"Kynnys",
    TYPE:"Tyyppi",
    TOTAL_MONEY_SPENT:"Rahaa käytetty kampanjan aikana yhteensä",
    NUMBER_OF_VISITS:"Käyntien määrä kampanjan aikana",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Viestin täytyy olla vähintään 10 merkkiä pitkä",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Viestin täytyy olla alle 350 merkkiä pitkä",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Viestin täytyy sisältää tekstiä",
    TECHNOLOGY:"Teknologia",
    TAP_WATER:"Juomavesi",
    REVERSE_OSMOSIS:"Käänteisosmoosi",
    SOFTENED_WATER:"Pehmennetty vesi",
    DOSER:"Annostelija",
    STATUS:"Tila",
    LAST_SYNCHRONIZATION:"Edellinen synkronointi",
    NO_OF_CURRENT_ALARMS:"Aktiivisten hälyytysten määrä",
    NO_OF_CURRENT_WARNINGS:"Aktiivisten varoitusten määrä",
    WEATHER:"Säätila",
    BOXES_WORK_HOURS_COUNTERS:"Pilttuiden käyttöajat",
    BOX_TOTAL_HOURS:"Kaikki käyttöajat",
    BOX_SERVICE_HOURS:"Kaikki käyttöajat (huolto)",
    BOX_COUNTER_HOURS:"tunnit",
    ALARMS_AND_WARNINGS:"Hälyytykset & varoitukset",
    FILTER_AND_BOILER:"Suodatin & lämmitin",
    FILTER_TOTAL_DAYS:"Suodattimen käyttöaika",
    BOILER_TOTAL_DAYS:"Lämmittimen käyttöaika",
    DAYS_UNIT:"Päiviä",
    SOFTENER:"Pehmennin",
    MANUAL_COLD_DRAIN:"Manuaalinen kylmätyhjennys",
    EL_COLD:"El. cold",
    DRAIN:"tyhjennys",
    TAP:"hana",
    WASTE:"Hukka",
    OSMOSIS:"osmoosi",
    DEMI_WATER:"Demi water",
    EL_RINSE:"El. m. rinse",
    BOILER:"Lämmitin",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"Lattialämmitys",
    DOSER_TANK:"Annostelijan tankki",
    EL_WASH:"El. m. wash",
    DETERGENT:"Pesuaine",
    VIBRATOR:"Täristin",
    UPDATE_FACILITY_SETTINGS:"Päivitä säädöt",
    GENERAL_SETTINGS:"Yleiset asetukset",
    LIGHTS:"Valot",
    GROUPS:"Ryhmät",
    ANTI_FREEZE:"Pakkassuojaus",
    AUTO:"Automaattinen",
    MANUAL:"Manuaalinen",
    ON:"Päällä",
    OFF:"Pois",
    TEMPERATURE:"Lämpötila",
    UPDATE_DEVICE:"Päivitä laitteen asetuksia",
    BOX_CLEAN_HOURS:"Pilttuun puhdistus laskuri (tuntia)",
    GROUP_COUNTERS:"Ryhmän laskurit",
    RESET:"Nollaa",
    CASH_COUNT:"Kolikkojen määrä",
    COINS_COUNT:"Polettien määrä",
    EUROKEY_COUNT:"Eurokey count",
    DOSER_WORK:"Annostelijan käyntiaika (sekuntia)",
    DOSER_PAUSE:"Annostelijan taukoaika (sekuntia)",
    DELAY_BFV:"BFV delay (ms)",
    DELAY_6M1:"6M1 delay (ms)",
    DELAY_LPS:"LPS delay (ms)",
    RESET_CASH_COUNT_ALL:"Nollaa kaikki kolikkolaskurit",
    RESET_COINS_COUNT_ALL:"Nollaa kaikki polettilaskurit",
    RESET_EUROKEY_COUNT_ALL:"Reset all Eurokey counters",
    FACILITY_DETAILS:"Laitteen tiedot",
    FACILITY_NAME:"Laitteen nimi",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Kuva ladattu onnistuneesti",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Tiedot päivitetty onnistuneesti",
    CONNECTED:"Yhteydessä",
    DISCONNECTED:"Ei yhteyttä",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Viesti suodatin",
    FACILITY:"Laite",
    APPLY:"Käytä",
    TIME:"Aika",
    LOCATION:"Paikka",
    ACKNOWLEDGED:"Hyväksytty",
    FILTERED_MESSAGES:"Suodatetut viestit",
    ACK:"Hyväksytty",
    NOT_ACK:"Ei hyväksytty",
    ALL:"Kaikki",
    ALL_FACILITIES:"Kaikki laitteet",
    ENTER_DATE_PLACEHOLDER:"Syötä päivämäärä",
    OP_NESTANAK_NAPONA:"Missing voltage on phase indicator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"High pressure pump circuit breaker dropped",
    OP_UPR_NAPON_24VAC_GRE:"Missing 24 VAC - circuit breaker 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Fresh water tank empty",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Mains water pump circuit breaker dropped",
    OP_MIN_NIVO_OMEKS_VODE:"Softened water tank empty",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Softened water pump circuit breaker dropped",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosis water tank empty",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosis water pump circuit breaker dropped",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosis production pump circuit breaker dropped",
    OP_BOJLER_GRESKA_MZS:"Water heater error",
    OP_CRPKA_PRASKA_GRE_MZS:"Hot water pump circuit breaker dropped",
    OP_DOZATOR_PRASKA_GRE_MZS:"Powder dosing motor circuit breaker dropped",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Powder dosing vibrator circuit breaker dropped",
    OP_MIN_PRASAK_TON_ALARM:"Powder mixing tank empty",
    OP_USIS_KOV_TURBINA_GRESKA:"Coin vacuuming turbine circuit breaker dropped",
    OP_FILTER_VODE_ZACEPLJEN:"Water filter blocked",
    OP_VISKTL_RESET_SATI_RADA:"High pressure pump service",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Water filter fault",
    OP_BOJLER_DANI_RADA:"Water heater fault",
    OPW_ALARM_VISOKOTL_PUMPA:"High pressure pump alarm",
    OPW_ALARM_FILTER_SERVIS:"Filter service alarm",
    OPW_ALARM_BOJLER_SERVIS:"Boiler service alarm",
    HAS_MEMBERS:"Valitussa ryhmässä on jäseniä ja sitä ei voida poistaa. Poista ensin jäsenet.",
    PERIODIC_SUMMARY_FOR:"Jakson yhteenveto raportti",
    PERIODIC_SUMMARY_REPORTS:"Jakson yhteenveto raportit",
    DATE_RANGE:"Päivämäärä väli",
    FINANCIAL_REPORT:"Liikevaihto raportti",
    GROSS_INCOME:"Bruttotulo",
    GROSS_INCOME_SUM:"Bruttotulo summa",
    COMMISSION_FEE:"Välityspalkkio",
    NET_INCOME:"Nettotulo (Laskutusta varten)",
    COMMISSION_FEE_DETAILS:"Välityspalkkio sisältää pankki / PayPal provision tai SMS palveluntarjoajien palkkion",
    LOYALTY_CREDITS_REPORT:"Paikallisten polettien raportti",
    LOYALTY_GIVEN:"Annettuja paikallisia poletteja",
    LOYALTY_USED:"Käytetyt paikalliset poletit",
    LOYALTY_SOLD:"Paikallisia poletteja ladattu",
    LOYALTY_TOTAL:"Yhteensä",
    LOYALTY_CURRENT_MONTH:"Kuluva kuukausi",
    SOMETHING_WENT_WRONG:"Jokin meni pieleen",
    MISSING_PAGE:"Pahoittelut, sivua ei löydy",
    TRY_AGAIN:"Yritä uudelleen",
    DEFAULT_ERROR_NAME:"Tuntematon virhe",
    DEFAULT_ERROR_DESCRIPTION:"Voitko yrittää uudelleen",
    MY_ACCOUNT_DETAILS:"Tilini tiedot",
    SAVE_CHANGES:"Tallenna muutokset",
    USERNAME:"Käyttäjänimi",
    FIRST_NAME:"Etunimi",
    LAST_NAME:"Sukunimi",
    USER_ROLE:"Käyttäjärooli",
    OLD_PASSWORD:"Vanha salasana",
    NEW_PASSWORD:"Uusi salasana",
    OLD_PASSWORD_REQUIRED:"Vanha salasana vaaditaan",
    NEW_PASSWORD_REQUIRED:"Uusi salasana vaaditaan",
    NEW_PASSWORD_REPEAT:"Vaaditaan uusi salasana uudelleen",
    NEW_PASSWORD_NOT_MATCH:"Salasanat eivät kohtaa",
    PASSWORD_DIFFERENT_VALIDATION:"Uuden salasanan täytyy olla eri kuin aikaisempi",
    PASSWORD_MIN_CHAR:"Salasanan pitää olla vähintään 8 merkkiä pitkä",
    PASSWORD_MAX_CHAR:"Salasana saa olla enintään 32 merkkiä pitkä",
    PASSWORD_PATTERN_VALIDATION:"Salasanan pitää sisältää vähintään yksi numero",
    ACCOUNT_MANAGEMENT:"Tilinhallinta",
    NOT_ACTIVE:"Ei aktiivinen",
    ASSIGN_ROLE:"Lisää rooli",
    UPDATE:"Päivitä",
    ADD_NEW_ACCOUNT:"Lisää uusi tili",
    EMAIL_REQUIRED:"Sähköpostiosoite vaaditaan",
    EMAIL_NOT_VALID:"Sähköpostiosoite ei ole hyväksytty",
    ADD_NEW_USER_TEXT:"Sähköposti joka sisältää aktivointilinkin on lähetetty annettuun sähköposti -osoitteeseen",
    UPDATE_USER_NOTIFICATION:"Tietosi on päivitetty onnistuneesti",
    CHANGED_PASSWORD_NOTIFICATION:"Salasanasi on päivitetty onnistuneesti",
    UPDATE_USER_GROUP_NOTIFICATION:"Käyttäjäryhmän nimi on päivitetty onnistuneesti",
    CREATE_USER_GROUP_NOTIFICATION:"Ryhmä on luotu onnistuneesti",
    DETELE_USER_GROUP_NOTIFICATION:"Ryhmä on poistettu onnistuneesti",
    EMPTY_GROUP_LIST_MSG:"Ryhmiä ei löydy. Aloita luomalla sellainen.",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Käyttäjä on onnistuneesti poistettu ryhmästä",
    ADD_USER_TO_GROUP_NOTIFICATION:"Käyttäjä on lisätty ryhmään onnistuneesti",
    ADD_USER_NOTIFICATION:"Lisäsit onnistuneesti uuden käyttäjän",
    DELETE_USER_NOTIFICATION:"Käyttäjän poisto onnistui",
    RESEND_USER_VERIFICATION_EMAIL:"Lähetit onnistuneesti uudelleen todentamis -sähköpostin",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Luo käyttäjäryhmän nimi",
    DELETE_USER:"Poista käyttäjä",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Haluatko varmasti poistaa käyttäjäryhmän?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Hyvä R2W käyttäjä",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Uskollisuussääntö käyntimäärälle",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Uskollisuussääntö käytetyille poleteille",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Uskollisuussääntö viikonpäivälle",
    REMOVE_CAMPAIGN_RULE_TITLE:"Kampanjasäännön poistaminen",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Haluatko varmasti poistaa kampanjasäännön?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Loit onnistuneesti uuden kampanjan",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Aktivoit kampanjan onnistuneesti",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Valmiita kampanjoita ei löydy. Aloita luomalla kampanja",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Viesti lähetetty onnistuneesti",
    COMPANY_ACCOUNTS:"Yritystilit",
    BUSSINESS_INVOICES_LIST:"Minun B2B laskut",
    LOCALE_TOKEN:"Paikallinen poletti",
    R2W:"Globaali poletti",
    START_MONTH:"Alku kuukausi",
    END_MONTH:"Loppu kuukausi",
    TOKEN_TYPE:"Poletin tyyppi",
    TOKEN_NUMBER:"Poletin numero",
    NOTHING_TO_DISPLAY:"* Ei näytettävää",
    CREATE_INVOICE:"Luo lasku",
    INVOICE:"Lasku",
    INVOICES:"Laskut",
    EDIT_INVOICE:"Muokkaa laskua",
    UPDATE_INVOICE_NOTIFICATION:"Muutit onnistuneesti laskun 'odottaa' tilaan",
    CURRENT_CHARGES:"Veloitukset nykyiseltä jaksolta",
    PAYMENTS_ON_HOLD:"Laskut käsittelyssä",
    FOR_INVOICING:"Laskutukseen",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Olet perumassa laskua",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Haluatko varmasti perua tämän laskun?",
    INVOICING_NOTIFICATION_HEADER:"Olet tekemässä laskutuksen",
    INVOICING_NOTIFICATION_TEXT:"Haluatko varmasti lähettää laskun?",
    SENT_INVOICE_NOTIFICATION:"Lasku lähetetty onnistuneesti",
    CANCELED_INVOICE_NOTIFICATION:"Lasku peruutettu onnistuneesti",
    INVOICE_DESCRIPTION_TEXT:"Lasku",
    INVOICE_STATE:"Laskun tila",
    INVOICE_NUMBER:"Laskun numero",
    INVOICE_TOTAL:"Yhteensä",
    SELECT_YEAR:"Valitse vuosi",
    DOWNLOAD:"Lataa PDF",
    INVOICE_NUMBER_HEADER:"Olet lähettämässä laskua numerolla",
    INVOICE_PAYMENT_CONFIRMATION:"Olet hyväksymässä maksua",
    INSERT_INVOICE_NUMBER:"Syötä laskun numero",
    INVOICED_WARNING:"Sähköpostia ei lähetetty. Ole hyvä ja odota ...",
    SEND_INVOICE:"Lähetä",
    INVOICE_ALL:"Kaikki",
    INVOICE_FROM_R2W:"R2W:ltä",
    INVOICE_TO_R2W:"R2W:lle",
    PAYMENT_REQUEST:"Maksupyyntö",
    PAYMENT_REQUEST_STATE:"Maksupyynnön tila",
    PAYMENT_REQUEST_NUMBER:"Maksupyynnön numero",
    FOR_PAYMENT_REQUEST:"Maksupyynnölle",
    PAYMENT_REQUEST_ON_HOLD:"Maksupyyntö käsittelyssä",
    DOWNLOAD_INVOICE:"Lataa lasku",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Lataus vaihtoehdot",
    B2B_SPEC:"B2B erittely",
    B2C_SPEC:"B2C Erittely",
    DOWNLOAD_PAYMENT_REQUEST:"Lataa maksupyyntö",
    LOYALTY_PREVIEW:"Uskollisuus katselmointi",
    ACTIVATED:"Aktivoitu",
    RUNNING:"Käynnissä",
    NOT_ACTIVATED:"Ei aktivoitu",
    FINISHED:"Valmis",
    DEPRECATED:"Käytöstä poistettu",
    UPCOMING:"Tulossa",
    NONE:"Yksilöllinen",
    STARTED:"Aloitettu",
    ENDS:"Päättyy",
    DEDICATED:"Omistettu",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Olet aktivoimassa",
    CAMPAIGN:"Kampanja",
    SEND_MESSAGE_NOTIFICATION:"Olet lähettämässä viestiä valitulle käyttäjäryhmälle",
    DIVISIBLE_TO_NUMBER:"Numeron tulee olla jaollinen",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Laitteen tyyppi",
    LISTENER:"Pienet laitteet",
    BRIDGE:"Pesupaikat",
    WASH_BOXES:"Pesupaikat",
    VACUUMS:"Imurit",
    SAVE_NEWS:"Tallenna uutiset",
    CREATE_NEW_NEWS:"Luo uusia uutisia",
    HISTORY_OF_ALL_NEWS:"Uutisten historia",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Kirjoita laitteen nimi",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Lisää laite",
    NEWS_TEXT:"Uutisten teksti",
    NEWS_TITLE:"Uutisten otsikko",
    DELETE_NEWS_CONFIRMATION:"Olet poistamassa uutisia",
    NEWS_DELETE_NOTIFICATION:"Uutiset poistettu onnistuneesti",
    NEWS_SAVE_NOTIFICATION:"Uutiset tallennettu onnistuneesti",
    NEWS_CREATION_DATE:"Luontipäivä",
    NO_TITLE:"Ei otsikkoa",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Uutisen tekstin täytyy olla lyhyempi kuin 255 merkkiä",
    NEWS_TEXT_REQUIRED_VALIDATION:"Uutisen teksti vaaditaan",
    NEWS_TITLE_REQUIRED_VALIDATION:"Uutisen otsikko vaaditaan",
    DEACTIVATE:"Deaktivoi",
    ASIDE_MENU_LOCAL_TOKENS:"Paikallisia poletteja",
    CREATE_NEW_LOCAL_TOKENS:"Anna uusia paikallisia poletteja",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:" Anna asiakkaan sähköpostiosoite ja paikallisten polettien määrä, jotka haluat antaa asiakkaalle",
    CREATE_TOKENS:"Anna poletteja",
    MINIMUM_ONE_TOKEN:"Arvon täytyy olla isompi kuin 0",
    CUSTOMER_EMAIL:"Asiakkaan sähköpostiosoite",
    AMOUNT_OF_TOKENS:"Polettien määrä",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Poletteja annettu onnistuneesti käyttäjälle",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Virhe annettaessa poletteja. Tarkasta asiakkaan sähköposti ja yritä uudelleen",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Annettujen polettien yhteenveto",
    ISSUED_AT:"Annettu kohteessa",
    ISSUED_BY:"Annettu toimesta",
    CODE:"Syötä koodi",
    REDEEMED_BY:"Lunastettu toimesta",
    REDEEMED_AT:"Lunastettu kohteessa",
    ASIDE_MENU_VOUCHERS:"Kupongit",
    PRINT:"Tulosta",
    VOUCHERS_OVERVIEW:"Kuponkejen yhteenveto",
    CREATE_NEW_VOUCHERS:"Luo uusia kuponkeja",
    CREATE_NEW_VOUCHERS_DESCRIPTION:" Luo uusi lunastettavissa oleva kuponkierä syöttämällä polettien määrä kuponkia kohden",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Polettien määrä kuponkia kohden",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Voit määrittää kupongille poletteja 1 ja 100 väliltä",
    NUMBER_OF_NEW_VOUCHERS:"Luotavien kuponkien määrä",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"You can create between 1 and {{size}} vouchers in a single batch",
    NEW_VOUCHERS_PREFIX:"Uusien kuponkien koodin etuliite",
    VALIDATION_VOUCHER_PREFIX:"Koodin etuliitteen pitää olla 4 merkkiä (Suuria kirjaimia ja/tai numeroita)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Uusien kuponkien luonnissa tapahtui virhe. Ole hyvä ja yritä uudelleen tai ota yhteyttä meidän asiakastukeen.",
    CREATE_VOUCHERS:"Luo kuponkeja",
    CREATING_VOUCHERS_SUCCESS:"Uudet kupongit luotiin onnistuneesti",
    PRINT_NEW_VOUCHERS:"Tulosta kuponkeja",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Syötä kuponkisarjan koodin etuliite tulostaaksesi koko kuponkisarjan. Vaihtoehtoisesti",
    PRINT_VOUCHERS_PREFIX:"Kuponki(sarjan) koodin etuliite",
    NO_VOUCHERS_FOR_PRINT:"Koodi etuliitettä vastaavia kuponkeja ei löytynyt tulostettavaksi",
    PRINT_VOUCHERS:"Tulosta kuponki/kuponkeja",
    VALIDATION_VOUCHER_CODE_FILTER:"Kupongin -haun pitää sisältää isojakirjaimia ja numeroita",
    FILTER_VOUCHERS_BY_CODE:"Hae kuponkeja lunastuskoodilla",
    FILTER_VOUCHERS:"Etsi kuponkeja",
    WASH_BOX:"Pesupaikka",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Digitaalisia polettia käytetty yhteensä",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Myydyt paikalliset poletit päivämäärän mukaan",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Käytetyt paikalliset poletit päivämäärän mukaan",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Annetut paikalliset poletit päivämäärän mukaan",
    LOCAL_TOKEN:"Paikallinen poletti",
    GIVEN_TOKEN:"Anna paikallisia poletteja",
    SOLD_TOKEN:"Myydyt paikalliset poletit",
    SMALL_MACHINES:"Pienet laitteet",
    R2W_Listener:"Listaaja",
    HHANLE_DEVICE:"HHanle pesupaikka",
    CODE_PREFIX_EXIST:"Koodin etuliite on jo käytössä",
    CODE_PREFIX_EXIST_TEXT:"Et voi luoda uutta kuponkia tällä koodin etuliitteellä. Ole hyvä ja syötä toinen.",
    MIN_FOUR_VALIDATION:"Tasan 4 merkkiä",
    ALL_INFORMATION_1:"Kaikki tiedot tästä",
    ALL_INFORMATION_2:"katoavat",
    ASIDE_MENU_TRANSACTIONS:"Tapahtumat",
    EXPENSES:"Kulut",
    TOPUPS:"Täydennykset",
    EXPENSES_LIST:"Kulujen listaus",
    USER_EMAIL:"Käyttäjä sähköposti",
    COMPANY_NAME:"Yrityksen nimi",
    TOPUPS_LIST:"Täydennyslista",
    CONSUMER:"Kuluttaja",
    SYSTEM_ADMIN:"Järjestelmän ylläpitäjä",
    MERCHANT_ADMIN:"Kauppiaan ylläpitäjä",
    COMPANY_ADMIN:"Yrityksen ylläpitäjä",
    FACILITY_ADMIN:"Laitteen ylläpitäjä",
    SUBSCRIBER:"Tilaaja",
    CONFIGURATOR:"Konfiguraattori",
    SETUP_UNIT_SERIAL_NO:"Sarjanumero",
    SETUP_UNIT_MATERIAL_NO:"Materiaalinumero",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi versio",
    TOTAL_TURNOVER:"Pesulaitteen liikevaihto",
    AVAILABILITY_ALL:"Saatavuus",
    AVAILIBILITY:"Pesupaikan saatavuus",
    AVAILABILITY_VACUUMS:"Imureiden saatavuus",
    WASH_BOX_INFO:"Pesupaikan tiedot",
    VACUUM_CLEANER_INFO:"Imureiden tiedot",
    BREAD_CRUMBS_SERVICE:"Palvelu",
    HOLIDAYS:"Lomat",
    HOLIDAY:"Loma",
    LIGHTS_ON:"Valot päälle",
    LIGHTS_OFF:"Valot pois",
    WASH_BOXES_ON:"Pesupaikka päällä",
    WASH_BOXES_OFF:"Pesupaikka pois päältä",
    VACUUMS_ON:"imurit päällä",
    VACUUMS_OFF:"imurit pois päältä",
    TURNOVER:"Liikevaihto",
    TURNOVER_MANUAL_WASH_UNIT:"Liikevaihto manuaalinen",
    STATUS_BAY_RUN_TIME:"Pesupaikan totaali käyttöaika",
    STATUS_BAY_PROGRAM_NAME:"Pesuohjelman nimi",
    STATUS_BAY_CREDIT:"Pesupaikan arvo",
    CLOUD_KREDIT:"Pilvessä oleva arvo",
    STATUS_VACUUM_RUN_TIME:"Imurin totaali käyttöaika",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Laitteen palvelut, pesupaikan ohjelma ja tämän hetkinen vikakoodi tilanne",
    UNAVAILABLE:"Laite ei ole käytettävissä",
    SHOW_HIDE_TABLE:"Näytä/piilota käyttötuntitaulukko",
    PROGRAM_NAME:"Ohjelman nimi",
    PROGRAM_COUNTER:"Ohjelma laskuri",
    NO_NAME:"Viitteellä ei ole nimeä",
    COUNTER_SERVICE_DATA:"Huoltotieto",
    NEED_SERVICE:"Huolto vaaditaan",
    PROGRAM_DATA:"Pesupaikan ohjelma -tieto",
    CURRENT_FAULT_DATA:"Tämän hetkiset viat",
    REFERENCE_DUE:"Mennessä",
    REFERENCE_SECONDS:"Sekuntia",
    REFERENCE_NAME:"Osan nimi",
    WASHBOX_NAME:"Pesupaikan nimi",
    FAULT_NAME:"Viankuvaus",
    FAULT_NUMBER:"Vikakoodi",
    CURRENT_FAULT_COUNT:"Aktiiviset viat",
    DEVICE_NOT_INSTALLED:"Laitetta ei ole asennettu",
    STATUS_READY:"Valmiina -tila",
    STATUS_ERROR:"Vikatila",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Ohjelmistovirhe",
    SOFTWARE_RESET:"Ohjelmistovirhe",
    EXTERNAL_PIN_RESET:"Ohjelmistovirhe",
    RESTART_OR_BROWNOUT_OCCURRED:"Ohjelmistovirhe",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Komponenttivirhe",
    COULD_NOT_SIMULATE_COIN:" Komponenttivirhe",
    ERROR_SETTING_INHIBIT_MODE:" Komponenttivirhe",
    OFFLINE_DEVICE:"Autonpesu Offline",
    TARIFFS:"Tariffit",
    DAY:"Päivä",
    NIGHT:"Yö",
    VOUCHER_CODE:"Kupongin koodi",
    DISMISS_ALARM:"Resetoi hälytys?",
    ALARM_ACTIVE:"Aktiiviset hälytykset",
    NO_ALARM_ACTIVE:"Ei aktiivisia hälytyksiä",
    ALARM_HISTORY:"Hälytys historia",
    MANAGING_TOKENS:"Polettien hallinta",
    EXPIRATION_DATE:"Vanhenemis aika",
    EXTEND_TOKEN_DATE:"Siirrä poletin vanhenemisaikaa",
    DELETE_TOKENS_FOR:"Poista poletit:",
    PUMP_TYPE:"Pumpun tyyppi",
    TURN_OFF_DEVICE:"Laitteen tila",
    OPERATION_DATA:"Käyttödata",
    PUMP_DATA:"Pumpun data",
    PUMP_NAME:"Pumpun nimi",
    POINT_NAME:"Pisteen nimi",
    CHANGER_INCOME:"Vaihtajan totaali tulo päivämäärän mukaan",
    SELECTED_OPEN:"Avoinna valittuna työaikana",
    ALWAYS_OPEN:"Avoinna aina (24/7)",
    CLOSED:"Suljettu",
    CLOSED_24:"Suljettu 24h",
    OPENED_24:"Avoinna 24h",
    MON:"Maanantai",
    TUE:"Tiistai",
    WED:"Keskiviikko",
    THU:"Torstai",
    FRI:"Perjantai",
    SAT:"Lauantai",
    SUN:"Sunnuntai",
    PRICING:"Hinnoittelu",
    PRICE:"Hinta",
    VALIDITY:"Voimassaolo",
    TOKEN_PACKAGES:"Polettipaketit",
    SINGLE_WASH:"Yksittäinen pesu",
    FACILITY_WORKING_HOURS:"Määritä käyttöajat valitulle laitteistolle",
    WORKING_HOURS_ALWAYS_OPEN:"Aina avoinna",
    WORKING_HOURS_ALWAYS_CLOSE:"Suljettu operaattorin toimesta",
    WORKING_HOURS_CUSTOM:"Syötä käyttöajat",
    KARCHER_ERROR_CODE:"Hälytyksen vikakoodi",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organisaatio",
    CREATE_ORGANIZATION:"Luo organisaatio",
    CREATE_ORGANIZATION_AS:"Luo ali-organisaatio",
    DELETE_ORGANIZATION:"Poista organisaatio",
    EDIT_ORGANIZATION:"Muokkaa organisaatiota",
    SUPPORTED_ORG_NAME:"Tuettu organisaatio",
    SUPPORTED_ORG_TYPE:"Tuen tyyppi",
    ORG_NAME:"Nimi",
    ORG_TYPE:"Tyyppi",
    SET_ORG_TITLE:"Luo ali-organisaatio",
    SET_SUPPORTED_ORG_TITLE:"Aseta tuettu ali-organisaatio",
    SAVE_ORGANIZATION:"Tallenna organisaatio",
    SELECT_ORGANIZATION_TYPE:"Valitse organisaation tyyppi",
    SELECT_ORGANIZATION_SELECTOR:"Valitse",
    SELECT_SUPPORTED_ORGANIZATION:"Valitse tuettu organisaatio",
    ORGANIZATION_DELETED:"Organisaatio onnistuneesti poistettu",
    ORGANIZATION_SAVED:"Organisaatio onnistuneesti tallennettu",
    ORGANIZATION_UPDATED:"Organisaatio onnistuneesti päivitetty",
    ALERTS:"Hälytykset",
    DEVICE_STATUS:"Laitteen tila",
    SITE_DETAILS:"Kohteen tiedot",
    ALARM_STATUS:"hälytyksen tila",
    FILTER:"Suodatettu:",
    FILTER_BY_ALERT_CENTER:"Suodatettu koodin, nimen tai kuvauksen mukaisesti",
    TOTAL_ALARM:"Yhteensä",
    LOW_ALARM:"Tapahtuma",
    MEDIUM_ALARM:"Toimintahäiriö",
    HIGH_ALARM:"Kriittinen virhe",
    NO_FACILITIES_NEARBY:"Lähettyvillä ei ole laitteita",
    GRAY_MAP:"Harmaasävyinen kartta",
    READY:"Valmis",
    WARNING:"Toimintahäiriö",
    ERROR:"Virhe",
    SITE_NAME:"Kohteen nimi",
    ACCOUNTS_INFO:"Tilin tiedot",
    USER_ORGANIZATION:"Käyttäjä organisaatio",
    ADD_USER_ORGANIZATION:"Lisää uusi organisaatio käyttäjä",
    EDIT_USER_ORGANIZATION:"Muokkaa organisaation käyttäjiä",
    SELECT_ROLE:"Valitse rooli",
    SELECT_ORGANIZATION:"Valitse organisaatio",
    SELECT_USER:"Valitse käyttäjä",
    USER_FOR_ORGANIZATION_CREATED:"Uusi käyttäjä luotu onnistuneesti",
    SELECT_REGION:"Valitse regioona",
    SELECT_LANGUAGE:"Valitse kieli",
    LOADING_DATA:"Ladataan tietoja, ole hyvä ja odota",
    ADMINISTRATOR:"Ylläpitäjä",
    TECHNICAL_SUPPORT:"Tekninen tuki",
    CONTROLLER:"Controller",
    EDIT_ORGANIZATION_USER:"Muokkaa käyttäjiä organisaatiossa",
    DELETE_ORGANIZATION_USER:"Poista käyttäjiä organisaatiossa",
    USER_UPDATED:"Käyttäjä päivitetty onniostuneesti",
    USER_CREATED:"Käyttäjä luotu onnistuneesti",
    ADDRESS:"Osoite",
    SUBSCRIPTIONS:"Tilaukset",
    RESOLVED_STATUS:"Ratkaistu",
    NOT_RESOLVED_STATUS:"Ei ratkaistu",
    ALERT_NAME:"Vian nimi",
    ALERT_DESCRIPTION:"Viankuvaus",
    ALERT_CODE:"Vikakoodi",
    ALERT_TYPE:"Viantyyppi",
    UNSUBSCRIBE:"Lopeta vian seuraaminen",
    SUBSCRIBE:"Seuraa vikaa",
    ALARM_SUBSCRIBED:"Onnistuneesti tilattu",
    UNSUBSCRIBED_CONFIRM:"Peruuta seuranta?",
    ALARM_UNSUBSCRIBED:"Seuranta onnistuneesti peruutettu",
    ASIDE_MENU_CASHLESS_SALES:"Rahaton myynti",
    FILTERED_CASHLESS_PAYMENTS:"suodata rahattomat myynnit",
    REFUND_DIALOG_TITLE:"Hyvitä tapahtuma?",
    REFUND_DIALOG_SUBTITLE:"Määrä voi olla pienempi kuin tai sama kuin tapahtuman arvo",
    REFUND:"Hyvitä",
    INPUT_NOT_VALID:"Syöttö ei kelpaa",
    REFUND_SUCCESSFULLY:"Hyvitys valitulle tapahtumalle suoritettu onnistuneesti",
    USER:"Käyttäjä",
    TRANSACTION_ID:"PSP reference",
    DEVICE_ID:"Laitteen ID",
    NET_AMOUNT:"Nettoarvo",
    REPORT_NAME:"Raportin nimi",
    TIME_FRAME:"Aikajakso",
    SUB_POINT:"Valitse alipiste",
    SUB_POINT_LIST_NOT_EXIST:"Alipisteiden listaa ei ole valitulle pesulaitteistolle",
    FACILITY_TYPE:"Laitteiston tyyppi",
    MACHINE_NAME:"Laitteen nimi",
    WASH_FACILITY_DETAILS:"Laitteiston tiedot",
    WASH_BAY_DETAILS:"Pesupaikan tiedot",
    DEVICES_INFO:"Laitteistolistaus",
    OPERATION_TIME_INFO:"Käyttöaika",
    OPERATION_TIME_VACUUM_INFO:"Käyttöaika imureille",
    OPERATION_TIME_ILLUMINATION_INFO:"Käyttöaika valaistukselle",
    AVAILABLE_TITLE:"Käytettävissä",
    UNAVAILABLE_TITLE:"Ei käytettävissä",
    CURRENT_PROGRAM:"Tämän hetkinen ohjelma",
    CREDITS:"Krediitit",
    DEVICE_NAME:"Laitteen nimi",
    ACTIVE_ALARMS:"Aktiiviset hälytykset",
    ALL_DAY:"Koko päivä",
    OPERATING_TIME_WASH_FACILITY:"Itsepalvelupesulaitteisto",
    OPERATING_TIME_VACUUMS:"Imurit",
    OPERATING_TIME_ILLUMINATION:"Valaistus",
    OPERATION_COUNTERS:"Käyttölaskurit",
    EDIT:"Muokkaa",
    WASHING_PROGRAMS:"Pesuohjelmat",
    INFO:"Tapahtuma",
    STATISTIC:"Tilasto",
    ROLLOVER_DOSING:"Annostelu",
    ROLLOVER_SPEED:"Nopeudet",
    ROLLOVER_RESETS:"Autonpesukoneen resetointi",
    ROLLOVER_RESETS_INFO:"Etäresetoinnin pitää täyttää paikalliset vaatimukset. Tärkeää: Ennen resetointia varmista, että autonpesukone on tyhjä.",
    RESET_ROLLOVER:"Resetoi autonpesukone",
    OPEN_DOOR_ROLLOVER:"Avaa",
    ROLLOVER_OPEN_DOOR_INFO:"Avaa pesuhallin ovi. Ole varovainen.",
    ROLLOVER_OPEN_DOOR:"Avaa ovi",
    APPLY_DOSING_CHANGES:"Hyväksy muutokset annostelussa",
    APPLY_SPEED_CHANGES:"Hyväksy nopeus muutokset",
    ACTUATION_SUCCESS:"Pyyntö lähetetty",
    REMAINING_TIME:"Jäljellä oleva aika",
    OPEN_24H:"Avoinna 24 tuntia",
    CLOSE_24H:"Suljettu 24 tuntia",
    VALIDATION_OPERATION_TIME:"Muoto ei ole oikei. Käytä tt:mm",
    ROLLOVER:"Autonpesukone",
    UPDATE_WASHING_PROGRAM:"Päivitä pesuohjelma",
    UPDATE_ACTUATORS:"Päivitä toimilaitteet",
    OPEN_ROLOVER_DOOR_TITLE:"Haluatko avata autonpesukoneen oven?",
    OPEN_ROLOVER_DOOR_CONTENT:"Oletko varma, että haluat avata oven?",
    RESET_ROLOVER_TITLE:"Haluatko resetoida autonpesukoneen?",
    RESET_ROLOVER_CONTENT:"Oletko varma, että haluat resetoida autonpesukoneen?",
    G0:"{{brand === 'r2w' ? 'Paikka 0' : 'Paikka 1'}}",
    G1:"{{brand === 'r2w' ? 'Paikka 1' : 'Paikka 2'}}",
    G2:"{{brand === 'r2w' ? 'Paikka 2' : 'Paikka 3'}}",
    G3:"{{brand === 'r2w' ? 'Paikka 3' : 'Paikka 4'}}",
    G4:"{{brand === 'r2w' ? 'Paikka 4' : 'Paikka 5'}}",
    G5:"{{brand === 'r2w' ? 'Paikka 5' : 'Paikka 6'}}",
    G6:"{{brand === 'r2w' ? 'Paikka 6' : 'Paikka 7'}}",
    G7:"{{brand === 'r2w' ? 'Paikka 7' : 'Paikka 8'}}",
    G8:"{{brand === 'r2w' ? 'Paikka 8' : 'Paikka 9'}}",
    G9:"{{brand === 'r2w' ? 'Paikka 9' : 'Paikka 10'}}",
    G10:"{{brand === 'r2w' ? 'Paikka 10' : 'Paikka 11'}}",
    U0:"{{brand === 'r2w' ? 'Imuri 0' : 'Imuri 1'}}",
    U1:"{{brand === 'r2w' ? 'Imuri 1' : 'Imuri 2'}}",
    U2:"{{brand === 'r2w' ? 'Imuri 2' : 'Imuri 3'}}",
    U3:"{{brand === 'r2w' ? 'Imuri 3' : 'Imuri 4'}}",
    U4:"{{brand === 'r2w' ? 'Imuri 4' : 'Imuri 5'}}",
    U5:"{{brand === 'r2w' ? 'Imuri 5' : 'Imuri 6'}}",
    U6:"{{brand === 'r2w' ? 'Imuri 6' : 'Imuri 7'}}",
    U7:"{{brand === 'r2w' ? 'Imuri 7' : 'Imuri 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Vikakoodiraportti luotu valitusta kohteesta",
    ALERT_CENTER_TITLE_BY_FACILITY:"Vikakoodiraportti luotu valitusta laitteesta",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Vikakoodiraportti",
    ERROR_MESSAGE_403:" You don't have privilege to use this api call. Error Code: 403",
    LAST_ACTIVE_PROGRAM:"Aktiivinen pesuohjelma / Edellinen aktiivinen pesuohjelma",
    PROGRAM_ID:"Pesuohjelman numero",
    PROGRAM_PRICE:"Pesuohjelman hinta",
    NORMAL_CHEMICAL_LEVEL:"Ok",
    LOW_CHEMICAL_LEVEL:"Täyttö vaaditaan",
    CHEMICAL_LEVEL:"Pesuaineiden pinnantasot (%)",
    ROLLOVER_STATUS:"Autonpesukoneen tila",
    ROLLOVER_STATUS_CODE_0:"Pesu tällä hetkellä poissa käytöstä",
    ROLLOVER_STATUS_CODE_1:"Aukioloajan ulkopuolella",
    ROLLOVER_STATUS_CODE_2:"Ohjelman aloitus hyväksytty",
    ROLLOVER_STATUS_CODE_3:"Aja koneeseen",
    ROLLOVER_STATUS_CODE_4:"Aja eteenpäin",
    ROLLOVER_STATUS_CODE_5:"Peruuta",
    ROLLOVER_STATUS_CODE_6:"Pysäytä auto",
    ROLLOVER_STATUS_CODE_7:"Pesu aktiivinen",
    ROLLOVER_STATUS_CODE_8:"Pesu pysäytetty",
    ROLLOVER_STATUS_CODE_9:"Pesu aktiivinen (tact)",
    ROLLOVER_STATUS_CODE_10:"Poistu peruuttaen",
    ROLLOVER_STATUS_CODE_11:"Hätäseis painettu",
    ROLLOVER_STATUS_CODE_12:"Poistu eteenpäin",
    ROLLOVER_STATUS_CODE_13:"Pakkassuojaus aktiivinen",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Peiliturvaraja vasen",
    ROLLOVER_STATUS_CODE_21:"Peiliturvaraja oikea",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kriittinen virhe",
    NO_ALARM:"Ei kriittistä virhettä",
    SOFTWARE_VERSION:"Ohjelmisto versio",
    SOFTWARE_DATE:"Ohjelmisto päivämäärä",
    SITE_ADDRESS:"Kohteen osoite",
    SECONDS:"Sekuntia",
    SERVICE_PART_NAME:"Huollon nimi:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Käyttö- ja huoltolaskuri",
    OPERATION_COUNTER:"Käyttölaskuri",
    SERVICE_COUNTER:"Huoltolaskuri",
    FAULT_CODE:"Vikakoodi",
    PRESSURE_TITLE:"Ilmanpaine",
    TIME_TITLE:"Aika",
    COUNTRY_TITLE:"Maa",
    CITY_TITLE:"Kaupunki",
    REGION_TITLE:"Alue",
    SELECT_POINTS_TO_SEARCH:"Valitse pisteet ...",
    LOGS_HISTORY:"Parametrien päivitys historia",
    ACTUATOR_REFERENCE:" Actuator reference",
    ACTUATOR_VALUE:" Actuator value",
    POINT_ID:" Point id",
    VALIDATION_NOT_VALID_RANGE:" Incorrect range",
    ENABLE_ROLLOVER_RESET:"Painamalla tätä ruutua vahvistat, että olet lukenut ja hyväksyt turvallisuusohjeet.",
    CHANGE_OF_PARAMETERS:"Muuta parametreja",
    SELECT_OPTIONS:"Valitse vaihtoehdot",
    AUTOMATIC:"Automaattinen",
    DESALTING:"Suolanpoisto toiminto",
    SEASON_WASH:"Pesuohjelma kausi",
    SPRING_PROGRAM:"Kevät pesuohjelmat",
    SUMMER_PROGRAM:"Kesä pesuohjelmat",
    AUTUMN_PROGRAM:"Syksy pesuohjelmat",
    WINTER_PROGRAM:"Talvi pesuohjelmat",
    DOOR_CONTROL:"Oviohjaus",
    SUMMER_DOOR_CONTROL:"Kesä, oviohjaus kesä asetuksella",
    WINTER_DOOR_CONTROL:"Talvi, oviohjaus talvi asetuksella",
    APPLY_PARAMETERS_CHANGES:"Hyväksy parametrien muutokset",
    WORKING_SCHEDULES:"Työaikataulut",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Loma-aika kohteelle luotu onnistuneesti",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Loma-ajat kohteelle päivitetty onnistuneesti",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Loma-ajat poistettu kohteelta onnistuneesti",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Työaikataulut etenevät onnistuneesti",
    HOLIDAY_SUCCESSFULLY_DELETED:"Loma poistettu onnistuneesti",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Kuivausapuaine vähissä",
    CHEM_LEVEL_LOW_SHAMPOO:"Harjashampoo vähissä",
    CHEM_LEVEL_LOW_FOAM:"Vaahto vähissä",
    CHEM_LEVEL_LOW_WAX_1:"Vaha vähissä",
    CHEM_LEVEL_LOW_POLISH_1:"Kiiltovaha vähissä",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Vannepesuaine vähissä",
    CHEM_LEVEL_LOW_WAX_2:"Vaha vähissä",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Renkaidenkiiltoaine vähissä",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Hyönteisirroite vähissä",
    CHEM_LEVEL_LOW_POLISH_2:"Kiiltovaha vähissä",
    CHEM_LEVEL_LOW_INTENSIVE:"Esipesuaine vähissä",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Vaahtosade -pesuaine vähissä",
    CHEM_LEVEL_DRYING_AGENT:"Kuivausavun määrä",
    CHEM_LEVEL_SHAMPOO:"Shampoon määrä",
    CHEM_LEVEL_FOAM:"Vaahdon määrä",
    CHEM_LEVEL_WAX_1:"Vahan määrä",
    CHEM_LEVEL_POLISH_1:"Kiiltovahan määrä",
    CHEM_LEVEL_RIM_CLEANER:"Vannepesuaineen määrä",
    CHEM_LEVEL_WAX_2:"Vahan määrä",
    CHEM_LEVEL_TYRE_SHINE:"Renkaidenkiiltoaineen määrä",
    CHEM_LEVEL_INSECT_REMOVER:"Hyönteisirrotteen määrä",
    CHEM_LEVEL_POLISH_2:"Kiiltovahan määrä",
    CHEM_LEVEL_INTENSIVE:"Esipesuaineen määrä",
    CHEM_LEVEL_FOAM_RAIN:"Vaahtosade -pesuaineen määrä",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Huoltolaskuri kattoharjan nostohihnoille",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Huoltolaskuri kattokuivaimen nostohihnoille",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Huoltolaskuri kattoharjanpyöritysmoottorin kaapelille",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Huoltolaskuri raikasvesipumpulle",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Huoltolaskuri kierrätysvesipumpulle",
    DRYING_AGENT:"Kuivausapu",
    FOAM_DRYING_AGENT:"Vaahtokuivausapuaine",
    SHAMPOO:"Shampoo",
    FOAM:"Vaahto",
    BRUSH_FOAM:"Vaahtoshampoo",
    WAX_1:"Vaha",
    FOAM_WAX_1:"Vaahtovaha",
    POLISH_1:"Kiiltovaha",
    RIM_CLEANING:"Vanteenpesuaine",
    WAX_2:"Vaha",
    FOAM_WAX_2:"Vaahtovaha",
    TYRE_SHINE:"Renkaankiillotusaine",
    INSECT_REMOVER:"Hyönteisirrote",
    POLISH_2:"Kiiltovaha",
    INTENSIVE_BASIC:"tavallinen esipesu",
    INTENSIVE_SIDE:"Esipesu kyljet",
    INTENSIVE_ROOF_SPRAY_BAR:"Esipesu katto",
    TAR_REMOVER:"Bituminpoisto",
    UNDER_CHASSIS_CONVERSATION:"Under chassis conversation",
    STATIONARY_PRE_SPRAY_ARCH:"Kiinteä esipesukaari",
    FOAM_RAIN:"Vaahtosade",
    PRE_CLEANING:"Esipesu",
    BRUSH:"Harja",
    CARE:"Huuhtelu",
    DRYING:"Kuivaus",
    DRYING_LOW_NOISE:"Kuivaus alennetulla äänellä",
    INTENSIVE_CLEANING:"Tehopuhdistus",
    BRUSH_CLEANING:"Harjapesu",
    EMPTY_RUN:"Tyhjä ylitys",
    DRYING_AID:"Kuivausapu",
    WAX:"Vaha",
    FOAM_WASH:"Vaahtopesu",
    POLISH:"Kiiltovaha",
    FOAM_POLISH:"Vaahtokiiltovaha",
    WHEEL_CLEANING:"Renkaanpesu",
    HIGH_PRESSURE_ROOF:"Kattokorkeapaine",
    HIGH_PRESSURE_SIDE:"Sivukorkeapaine",
    DRYER_FORWARD:"Kuivaus eteenpäin",
    DRYER_BACKWARD:"Kuivaus taaksepäin",
    DELETE_ALL_HOLIDAYS:"Poista kaikki lomat valitulta kohteelta",
    CREATE_NEW_HOLIDAY:"Luo uusi",
    RESET_INPUTS:"Reset all holidays inputs",
    TWENTY_FOUR_HOURS_OPEN:"Avoinna 24 tuntia",
    EVERY_YEAR:"Vuosittain",
    DELETE_HOLIDAY:"Poista loma ",
    ADD_NEW_HOLIDAY:"Luo uusi loma",
    HOLIDAYS_LIST:"Listaus olemassa olevista lomista",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Poista kaikki lomat valitulta kohteelta",
    VALIDATION_HOLIDAY_DATE:"Muoto on väärä. Käytä kk-pp",
    FOR_DATE:"Päivämäärälle",
    WITH_ID:"Tunnisteella",
    FROM_HOURS:"Alkaen tunnista",
    FROM_MINUTES:"Alkaen minuutista",
    TO_HOURS:"Päättyen tuntiin",
    TO_MINUTES:"Päättyen minuuttiin",
    NOT_MATCH:"Ei täsmää",
    START:"Alkaen",
    STOP:"Päättyen",
    DAILY_TIME:"24h lista",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Yksilöllinen aika-asetus",
    PROGRAM_NOT_STARTED:"Ohjelmaa ei aloitettu vielä",
    JETWASH:"Itsepalvelupesujärjestelmä",
    KARCHER_REPORT_1:"Autonpesukone: Liikevaihto pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_2:"Autonpesukone: Aloitetut pesut ohjelmittain ja yhteensä",
    KARCHER_REPORT_3:"Autonpesukone: Suoritetut pesut pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_4:"Autonpesukone: Maksuautomaatista käynnistettyjen pesujen määrä per pesuohjelma ja yhteensä",
    KARCHER_REPORT_5:"Autonpesukone: Manuaalisesti käynnistettyjen pesuohjelmien määrä pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_6:"Autonpesukone: Keskeytettyjen pesujen päärä pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_7:"Autonpesukone: Sähkönsyötönhäiriöiden määrä",
    KARCHER_REPORT_8:"SB-Laitteistot: Käyttöajat pesuohjelmittain suodatettuna per pesupaikka ja yhteensä",
    KARCHER_REPORT_9:"SB-Laitteistot: Liikevaihto indikaatio per pesupaikka ja yhteensä",
    KARCHER_REPORT_10:"SB-Laitteistot: Poletit/Kolikot laskuri per kolikkokanava",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Tuorevesipumppu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Kierrätysvesipumppu",
    OPERATION_COUNTER_HP_PUMP_1:"Korkeapainepumppu 1",
    OPERATION_COUNTER_HP_PUMP_2:"Korkeapainepumppu 2",
    RELEASE_NOTES:"Aplikaatiovarsio ja julkaisu ilmoitukset",
    BACKEND_RELEASE_NOTES:"Alustan julkaisu ilmoitukset:",
    FRONTEND_RELEASE_NOTES:"Verkko aplikaation julkaisu ilmoitukset:",
    SELECTED_FACILITY_TIMEZONE:"Aikavyöhyke valitulle laitteistolle",
    REFRESH_PAGE:"Päivitä sivu",
    REFRESH_MAPS:"Päivitä kartta",
    PUMPS:"Pumput",
    RUN_TIME:"Käyntiaika",
    RUN_TIME1:"Käyntiaika 1",
    RUN_TIME2:" Käyntiaika 2",
    PROGRAM_RUNTIME_ACTUATOR:"Actuator for run time",
    PROGRAM_RUNTIME_ACTUATOR_1:"Actuator for run time 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Actuator for run time 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimi arvo on 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maksimi arvo on 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Käytä hinta formaattina x.xx",
    ACTUATION_NOT_ALLOWED:"Aktivointi ei ole sallittu nykyiselle käyttäjäroolille",
    MAINTENANCE_DAYS:"Huoltoon päiviä",
    MAINTENANCE_WASHES:"Huoltoon pesuja",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Total income POS",
    PROPAGATE:"Propagate",
    ALL_DAY_HOURS_SELECTOR:"24 hours type selector",
    GET_OPERATING_TIME_FROM_SITE:"Get operating time for current device from site working schedules",
    USER_NOT_VALID:" Käyttäjä ei kelpaa. Kokeile toisella tilin tunnistetiedoilla.",
    VERIFIED:"Varmistettu",
    RESEND_VERIFICATION_MAIL:"Lähetä uudelleen varmistus sähköposti",
    RETURN_TO_DASHBOARD:"Palaa etusivulle",
    ERROR_PAGE_BAD_REQUEST:"400 Bad Request.",
    WASHES:"Pesujen määrä",
    TIME_TO_SERVICE:"Aikaa huoltoon",
    ACCOUNT_ALREADY_ACTIVATED:"Käyttäjätili on jo käytössä",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    INFO_TITLE: "Info",
    HOURLY: "Tunneittain",
    DAILY: "Päivittäin",
    WEEKLY: "Viikoittain",
    MONTHLY: "Kuukausittain",
    YEARLY: "Vuosittain",
    DELETE_ITEM_SUCCESS:"Onnistuit poistamaan kohteen",
    STATE: "Osavaltio",
    AVAILABILITY_STATUS_1: "Yksikkö avoinna",
    AVAILABILITY_STATUS_2: "Yksikkö suljettu (loma)",
    AVAILABILITY_STATUS_3: "Yksikkö suljettu (toiminta-aika)",
    AVAILABILITY_STATUS_4: "Yksikkö suljettu (vika)",
    AVAILABILITY_STATUS_5: "Yksikkö suljettu (muu syy)",
    AVAILABILITY_VACUUMS_STATUS_1: "Imurit eivät asennettu",
    AVAILABILITY_VACUUMS_STATUS_2: "Imurit avoinna",
    AVAILABILITY_VACUUMS_STATUS_3: "Imurit suljettu (loma)",
    AVAILABILITY_VACUUMS_STATUS_4: "Imurit suljettu (toiminta-aika)",
    AVAILABILITY_VACUUMS_STATUS_5: "Imurit suljettu (vika)",
    AVAILABILITY_VACUUMS_STATUS_6: "Imurit suljettu (muu syy)",
    ECOM_AMOUNT: "Kokonais-Ecom kaikille paikoille",
    CAPTURED: "Tallennettu",
    DELETE_COMPANY_HISTORY_INFO:"Tämä toiminto poistaa kaikki yrityksesi raporttitiedot. Tätä toimintoa ei voi peruuttaa.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Oletko varma, että haluat pysyvästi poistaa kaikki raporttitiedot?",
    VALUE_DATE: "Arvopäivä",
    KARCHER_EVENT_NAME_1: "Peruslämmönvaihdin regeneroitu",
    KARCHER_EVENT_NAME_2: "Peruslämmönvaihtimen regenerointi päättyi",
    KARCHER_EVENT_NAME_3: "Materiaali / sarjanumero",
    KARCHER_EVENT_NAME_4: "Järjestelmä on desinfioitu",
    KARCHER_EVENT_NAME_5: "HP-pumppu 1 desinfioitu",
    KARCHER_EVENT_NAME_6: "HP-pumppu 2 desinfioitu",
    KARCHER_EVENT_NAME_7: "HP-pumppu 3 desinfioitu",
    KARCHER_EVENT_NAME_8: "HP-pumppu 4 desinfioitu",
    KARCHER_EVENT_NAME_9: "HP-pumppu 5 desinfioitu",
    KARCHER_EVENT_NAME_10: "Pesuasema 1 lukittu",
    KARCHER_EVENT_NAME_11: "Pesuasema 2 lukittu",
    KARCHER_EVENT_NAME_12: "Pesuasema 3 lukittu",
    KARCHER_EVENT_NAME_13: "Pesuasema 4 lukittu",
    KARCHER_EVENT_NAME_14: "Pesuasema 5 lukittu",
    KARCHER_EVENT_NAME_15: "Pesuasema 6 lukittu",
    KARCHER_EVENT_NAME_16: "Pesuasema 7 lukittu",
    KARCHER_EVENT_NAME_17: "Pesuasema 8 lukittu",
    KARCHER_EVENT_NAME_18: "Päivitys aloitettu",
    KARCHER_EVENT_NAME_19: "Päivitys valmis",
    KARCHER_EVENT_NAME_20: "WS Reg aloitus",
    KARCHER_EVENT_NAME_21: "WS Reg loppu",
    KARCHER_EVENT_NAME_22: "WS 75% sensori",
    KARCHER_EVENT_NAME_23: "Tekninen vika",
    KARCHER_EVENT_NAME_24: "Käyttöhäiriö",
    KARCHER_EVENT_NAME_25: "Yksikkö päällä",
    KARCHER_EVENT_NAME_26: "Yksikkö pois päältä",
    KARCHER_EVENT_NAME_27: "Laatikko 1 suljettu",
    KARCHER_EVENT_NAME_28: "Laatikko 2 suljettu",
    KARCHER_EVENT_NAME_29: "Laatikko 3 suljettu",
    KARCHER_EVENT_NAME_30: "Laatikko 4 suljettu",
    KARCHER_EVENT_NAME_31: "Laatikko 5 suljettu",
    KARCHER_EVENT_NAME_32: "Laatikko 6 suljettu",
    KARCHER_EVENT_NAME_33: "Laatikko 7 suljettu",
    KARCHER_EVENT_NAME_34: "Laatikko 8 suljettu",
    KARCHER_EVENT_NAME_35: "HP-pumppuasema 1",
    KARCHER_EVENT_NAME_36: "HP-pumppuasema 2",
    KARCHER_EVENT_NAME_37: "HP-pumppuasema 3",
    KARCHER_EVENT_NAME_38: "HP-pumppuasema 4",
    KARCHER_EVENT_NAME_39: "HP-pumppuasema 5",
    KARCHER_EVENT_NAME_40: "HP-pumppuasema 6",
    KARCHER_EVENT_NAME_41: "HP-pumppuasema 7",
    KARCHER_EVENT_NAME_42: "HP-pumppuasema 8",
    KARCHER_EVENT_NAME_43: "Poltin",
    KARCHER_EVENT_NAME_44: "Polttimen tuuletin",
    KARCHER_EVENT_NAME_45: "Lämminvesipumppu",
    KARCHER_EVENT_NAME_46: "Pakkassuojapumppu",
    KARCHER_EVENT_NAME_47: "Osmosipumppu",
    KARCHER_EVENT_NAME_48: "Lattialämmitys",
    KARCHER_EVENT_NAME_49: "Letkun lämmitys",
    KARCHER_EVENT_NAME_50: "Mikro/vannepesu",
    KARCHER_EVENT_NAME_51: "Alustan pesupumppu",
    KARCHER_EVENT_NAME_52: "Vaahtopumppu Booster",
    KARCHER_EVENT_NAME_53: "Imuri 1",
    KARCHER_EVENT_NAME_54: "Imuri 2",
    KARCHER_EVENT_NAME_55: "Imuri 3",
    KARCHER_EVENT_NAME_56: "Imuri 4",
    KARCHER_EVENT_NAME_57: "Imuri 5",
    KARCHER_EVENT_NAME_58: "Imuri 6",
    KARCHER_EVENT_NAME_59: "Imuri 7",
    KARCHER_EVENT_NAME_60: "Imuri 8",
    KARCHER_EVENT_NAME_61: "Imuri 9",
    KARCHER_EVENT_NAME_62: "Imuri 10",
    KARCHER_EVENT_NAME_63: "Imuri 11",
    KARCHER_EVENT_NAME_64: "Imuri 12",
    KARCHER_EVENT_NAME_65: "Vanteen pesupumppu",
    KARCHER_EVENT_NAME_66: "Micropumppu",
    KARCHER_EVENT_NAME_67: "Tehopesupumppu",
    KARCHER_EVENT_NAME_68: "Imuri 1 turbiini",
    KARCHER_EVENT_NAME_69: "Imuri 1 suodatin",
    KARCHER_EVENT_NAME_70: "Imuri 2 turbiini",
    KARCHER_EVENT_NAME_71: "Imuri 2 suodatin",
    KARCHER_EVENT_NAME_72: "Imuri 3 turbiini",
    KARCHER_EVENT_NAME_73: "Imuri 3 suodatin",
    KARCHER_EVENT_NAME_74: "Imuri 4 turbiini",
    KARCHER_EVENT_NAME_75: "Imuri 4 suodatin",
    KARCHER_EVENT_NAME_76: "Imuri 5 turbiini",
    KARCHER_EVENT_NAME_77: "Imuri 5 suodatin",
    KARCHER_EVENT_NAME_78: "Imuri 6 turbiini",
    KARCHER_EVENT_NAME_79: "Imuri 6 suodatin",
    KARCHER_EVENT_NAME_80: "Imuri 7 turbiini",
    KARCHER_EVENT_NAME_81: "Imuri 7 suodatin",
    KARCHER_EVENT_NAME_82: "Imuri 8 turbiini",
    KARCHER_EVENT_NAME_83: "Imuri 8 suodatin",
    KARCHER_EVENT_NAME_84: "Imuri 9 turbiini",
    KARCHER_EVENT_NAME_85: "Imuri 9 suodatin",
    KARCHER_EVENT_NAME_86: "Imuri 10 turbiini",
    KARCHER_EVENT_NAME_87: "Imuri 10 suodatin",
    KARCHER_EVENT_NAME_88: "Imuri 11 turbiini",
    KARCHER_EVENT_NAME_89: "Imuri 11 suodatin",
    KARCHER_EVENT_NAME_90: "Imuri 12 turbiini",
    KARCHER_EVENT_NAME_91: "Imuri 12 suodatin",
    INSERT_TOKEN: "Lisää tunnisteet ja käynnistä palvelu",
    OPEN_SESSION: "Istunto avattu onnistuneesti",
    IN_PROGRESS: "Meneillään ...",
    TOKEN_INSERTED: "Tunnisteet lisätty onnistuneesti",
    EXPIRED_SESSION: "Istunto vanhentunut",
    TWO_DIGIT_INTEGER_VALIDATION: "Käytä korkeintaan kaksinumeroista kokonaislukua",
    KARCHER_OPERATION_COUNTER_1: "Pesuasema 1 HP-pumppu",
    KARCHER_OPERATION_COUNTER_2: "Pesuasema 1 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_3: "Pesuasema 1 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_4: "Pesuasema 1 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_5: "Pesuasema 1 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_6: "Pesuasema 2 HP-pumppu",
    KARCHER_OPERATION_COUNTER_7: "Pesuasema 2 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_8: "Pesuasema 2 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_9: "Pesuasema 2 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_10: "Pesuasema 2 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_11: "Pesuasema 3 HP-pumppu",
    KARCHER_OPERATION_COUNTER_12: "Pesuasema 3 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_13: "Pesuasema 3 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_14: "Pesuasema 3 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_15: "Pesuasema 3 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_16: "Pesuasema 4 HP-pumppu",
    KARCHER_OPERATION_COUNTER_17: "Pesuasema 4 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_18: "Pesuasema 4 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_19: "Pesuasema 4 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_20: "Pesuasema 4 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_21: "Pesuasema 5 HP-pumppu",
    KARCHER_OPERATION_COUNTER_22: "Pesuasema 5 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_23: "Pesuasema 5 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_24: "Pesuasema 5 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_25: "Pesuasema 5 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_26: "Pesuasema 6 HP-pumppu",
    KARCHER_OPERATION_COUNTER_27: "Pesuasema 6 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_28: "Pesuasema 6 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_29: "Pesuasema 6 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_30: "Pesuasema 6 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_31: "Pesuasema 7 HP-pumppu",
    KARCHER_OPERATION_COUNTER_32: "Pesuasema 7 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_33: "Pesuasema 7 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_34: "Pesuasema 7 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_35: "Pesuasema 7 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_36: "Pesuasema 8 HP-pumppu",
    KARCHER_OPERATION_COUNTER_37: "Pesuasema 8 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_38: "Pesuasema 8 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_39: "Pesuasema 8 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_40: "Pesuasema 8 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosipumppu",
    KARCHER_OPERATION_COUNTER_42: "Kuuman veden generaattori",
    KARCHER_OPERATION_COUNTER_43: "Jäänsuojapumppu",
    KARCHER_OPERATION_COUNTER_44: "WSO-suodatin",
    KARCHER_OPERATION_COUNTER_45: "Pesuaseman lämmityspumppu",
    KARCHER_OPERATION_COUNTER_46: "Kuuman veden pumppu",
    KARCHER_OPERATION_COUNTER_47: "Vaahdotusletkun lämmitys",
    KARCHER_OPERATION_COUNTER_48: "Renkaanpesupumppu",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulsiopumppu",
    KARCHER_OPERATION_COUNTER_50: "Tehovaahtopumppu",
    KARCHER_OPERATION_COUNTER_51: "Pölynimuri 1 turbiini 1",
    KARCHER_OPERATION_COUNTER_52: "Pölynimuri 1 suodatin 1",
    KARCHER_OPERATION_COUNTER_53: "Pölynimuri 1 turbiini 2",
    KARCHER_OPERATION_COUNTER_54: "Pölynimuri 1 suodatin 2",
    KARCHER_OPERATION_COUNTER_55: "Pölynimuri 2 turbiini 1",
    KARCHER_OPERATION_COUNTER_56: "Pölynimuri 2 suodatin 1",
    KARCHER_OPERATION_COUNTER_57: "Pölynimuri 2 turbiini 2",
    KARCHER_OPERATION_COUNTER_58: "Pölynimuri 2 suodatin 2",
    KARCHER_OPERATION_COUNTER_59: "Pölynimuri 3 turbiini 1",
    KARCHER_OPERATION_COUNTER_60: "Pölynimuri 3 suodatin 1",
    KARCHER_OPERATION_COUNTER_61: "Pölynimuri 3 turbiini 2",
    KARCHER_OPERATION_COUNTER_62: "Pölynimuri 3 suodatin 2",
    KARCHER_OPERATION_COUNTER_63: "Pölynimuri 4 turbiini 1",
    KARCHER_OPERATION_COUNTER_64: "Pölynimuri 4 suodatin 1",
    KARCHER_OPERATION_COUNTER_65: "Pölynimuri 4 turbiini 2",
    KARCHER_OPERATION_COUNTER_66: "Pölynimuri 4 suodatin 2",
    KARCHER_OPERATION_COUNTER_67: "Pölynimuri 5 turbiini 1",
    KARCHER_OPERATION_COUNTER_68: "Pölynimuri 5 suodatin 1",
    KARCHER_OPERATION_COUNTER_69: "Pölynimuri 5 turbiini 2",
    KARCHER_OPERATION_COUNTER_70: "Pölynimuri 5 suodatin 2",
    KARCHER_OPERATION_COUNTER_71: "Pölynimuri 6 turbiini 1",
    KARCHER_OPERATION_COUNTER_72: "Pölynimuri 6 suodatin 1",
    KARCHER_OPERATION_COUNTER_73: "Pölynimuri 6 turbiini 2",
    KARCHER_OPERATION_COUNTER_74: "Pölynimuri 6 suodatin 2",
    KARCHER_OPERATION_COUNTER_75: "Kondenssiveden poisto kompressorista",
    KARCHER_OPERATION_COUNTER_76: "Tarkista jäänsuojausjärjestelmä",
    KARCHER_OPERATION_COUNTER_77: "Polttimen tuuletin",
    KARCHER_OPERATION_COUNTER_78: "Vaahtovahvistinpumppu",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Tietoluettelo on suurempi kuin 10000 kohdetta",
    KARCHER_POINT_NAME_1: "Pyhäpäivä",
    KARCHER_POINT_NAME_2: "Maanantai",
    KARCHER_POINT_NAME_3: "Tiistai",
    KARCHER_POINT_NAME_4: "Keskiviikko",
    KARCHER_POINT_NAME_5: "Torstai",
    KARCHER_POINT_NAME_6: "Perjantai",
    KARCHER_POINT_NAME_7: "Lauantai",
    KARCHER_POINT_NAME_8: "Sunnuntai",
    KARCHER_POINT_NAME_9: "Imurit Pyhäpäivä",
    KARCHER_POINT_NAME_10: "Imurit Maanantai",
    KARCHER_POINT_NAME_11: "Imurit Tiistai",
    KARCHER_POINT_NAME_12: "Imurit Keskiviikko",
    KARCHER_POINT_NAME_13: "Imurit Torstai",
    KARCHER_POINT_NAME_14: "Imurit Perjantai",
    KARCHER_POINT_NAME_15: "Imurit Lauantai",
    KARCHER_POINT_NAME_16: "Imurit Sunnuntai",
    KARCHER_POINT_NAME_17: "Valaistus Pyhäpäivä",
    KARCHER_POINT_NAME_18: "Valaistus Maanantai",
    KARCHER_POINT_NAME_19: "Valaistus Tiistai",
    KARCHER_POINT_NAME_20: "Valaistus Keskiviikko",
    KARCHER_POINT_NAME_21: "Valaistus Torstai",
    KARCHER_POINT_NAME_22: "Valaistus Perjantai",
    KARCHER_POINT_NAME_23: "Valaistus Lauantai",
    KARCHER_POINT_NAME_24: "Valaistus Sunnuntai",
    KARCHER_POINT_NAME_25: "Ohjelma 0",
    KARCHER_POINT_NAME_26: "Ohjelma 1",
    KARCHER_POINT_NAME_27: "Ohjelma 2",
    KARCHER_POINT_NAME_28: "Ohjelma 3",
    KARCHER_POINT_NAME_29: "Ohjelma 4",
    KARCHER_POINT_NAME_30: "Ohjelma 5",
    KARCHER_POINT_NAME_31: "Ohjelma 6",
    KARCHER_POINT_NAME_32: "Ohjelma 7",
    KARCHER_POINT_NAME_33: "Ohjelma 8",
    KARCHER_POINT_NAME_34: "Ohjelma 9",
    KARCHER_POINT_NAME_35: "Ohjelma 10",
    KARCHER_POINT_NAME_36: "Ohjelma 11",
    KARCHER_POINT_NAME_37: "Ohjelma 12",
    KARCHER_POINT_NAME_38: "Ohjelma 13",
    KARCHER_POINT_NAME_39: "Ohjelma 14",
    KARCHER_POINT_NAME_40: "Ohjelma 15",
    KARCHER_POINT_NAME_41: "Ohjelma 16",
    KARCHER_POINT_NAME_42: "Ohjelma 17",
    KARCHER_POINT_NAME_43: "Ohjelma 18",
    KARCHER_POINT_NAME_44: "Ohjelma 19",
    KARCHER_POINT_NAME_45: "Ohjelma 20",
    KARCHER_POINT_NAME_46: "Ohjelma 21",
    KARCHER_POINT_NAME_47: "Ohjelma 22",
    KARCHER_POINT_NAME_48: "Ohjelma 23",
    KARCHER_POINT_NAME_49: "Ohjelma 24",
    KARCHER_POINT_NAME_50: "Ohjelma 25",
    KARCHER_POINT_NAME_51: "Ohjelma 26",
    KARCHER_POINT_NAME_52: "Ohjelma 27",
    KARCHER_POINT_NAME_53: "Ohjelma 28",
    KARCHER_POINT_NAME_54: "Ohjelma 29",
    KARCHER_POINT_NAME_55: "Ohjelma 30",
    KARCHER_POINT_NAME_56: "Ohjelma 31",
    KARCHER_POINT_NAME_57: "Ohjelma 32",
    QR_CODE: "QR-koodi",
    ACCEPT_TERMS_AND_CONDITIONS: "Hyväksy käyttöehdot",
    CREATE_AND_PRINT_VOUCHERS: "Luo ja tulosta kuponkeja",
    CODE_PREFIX_QUESTION: "Koodin etuliitettä ei ole syötetty",
    CODE_PREFIX_QUESTION_TEXT: "Haluatko jatkaa ilman koodin etuliitettä?",
    ISSUED_DATE: "Myöntämispäivä",
    VOUCHER_VALIDITY_DAYS: "Kupongin voimassaolo (päivää)",
    VALIDATION_ONLY_NUMBERS: "Vain numerot ovat sallittuja",
    REPRINT_VOUCHERS: "Tulosta kopio kupongista",
    EXPIRY_DATE: "Voimassa asti"
  });
})();
